export const GET_PAYMENT_METHOD_DEF = "GET_PAYMENT_METHOD_DEF"
export const GET_PAYMENT_METHOD_DEF_SUCCESS = "GET_PAYMENT_METHOD_DEF_SUCCESS"
export const GET_PAYMENT_METHOD_DEF_FAIL = "GET_PAYMENT_METHOD_DEF_FAIL"

export const API_ERROR = "API_ERROR"
